/** @jsxImportSource @emotion/react */
import { useTheme } from '@emotion/react';
import Box from '@mui/material/Box';
import makeSolarSummaryCardStyles from './makeSolarSummaryCardStyles';

/**
 * One themed summary card shared across the OLB screens: an optional heading and
 * one or more label/value rows. The address step passes a single row and no
 * heading; the review and confirmation screens pass several rows.
 */
const SolarSummaryCard = ({
  heading,
  rows,
  inline = false,
  dividers = false,
  dataTestId = 'solarSummaryCard',
}) => {
  const theme = useTheme();
  const classes = makeSolarSummaryCardStyles({ theme, inline, dividers });

  return (
    <Box css={classes.summary} data-testid={dataTestId}>
      {heading && <Box css={classes.heading}>{heading}</Box>}
      {rows.map((row) => (
        <Box css={classes.summaryText} key={row.label}>
          <Box css={classes.summaryLabel}>{row.label}</Box>
          <Box css={classes.summaryValue} data-testid={row.valueTestId}>
            {row.value}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default SolarSummaryCard;
